import { defaultSiteCms, buildDefaultSiteCms } from "../cms/defaultSiteContent";

const KEY = "partyboss_site_cms_v1";

function isPlainObject(v) {
  return v != null && typeof v === "object" && !Array.isArray(v);
}

export function deepMerge(base, patch) {
  if (!isPlainObject(patch)) return base;
  const out = Array.isArray(base) ? [...base] : { ...base };
  for (const k of Object.keys(patch)) {
    const pv = patch[k];
    const bv = out[k];
    if (isPlainObject(pv) && isPlainObject(bv)) {
      out[k] = deepMerge(bv, pv);
    } else {
      out[k] = pv;
    }
  }
  return out;
}

export function loadMergedCms() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return buildDefaultSiteCms();
    const parsed = JSON.parse(raw);
    return deepMerge(buildDefaultSiteCms(), parsed);
  } catch {
    return buildDefaultSiteCms();
  }
}

export function saveFullCms(next) {
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch (e) {
    console.error("CMS save failed (quota?)", e);
    throw e;
  }
}

export function saveCmsPatch(patch) {
  const merged = deepMerge(loadMergedCms(), patch);
  saveFullCms(merged);
  return merged;
}

export function resetCmsToDefaults() {
  localStorage.removeItem(KEY);
  return buildDefaultSiteCms();
}

export function exportCmsJson(cms) {
  return JSON.stringify(cms, null, 2);
}

export function importCmsJsonString(str) {
  const parsed = JSON.parse(str);
  const merged = deepMerge(buildDefaultSiteCms(), parsed);
  saveFullCms(merged);
  return merged;
}

export { defaultSiteCms, KEY as CMS_LOCALSTORAGE_KEY };
